import { Component, Input } from "@angular/core";

@Component({
    selector: "percentage-progress",
    templateUrl: "./percentage-progress.component.html",
    styleUrls: ["./percentage-progress.component.scss"],
    standalone: false
})
export class PercentageProgressComponent {
    @Input() percentage: number;
    @Input() decreasing: boolean;
    @Input() color = "#3D3D3D";
    @Input() fallbackValue: string | undefined;
    @Input() comparisionValue: number | undefined;
}

export interface IPercentageProresss {
    percentage: number;
    decreasing?: boolean;
    color?: string;
    comparisionValue?: number;
}
